import { Component, Input, OnInit, OnChanges, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Validators, UntypedFormGroup, FormControl } from '@angular/forms';
import { map, tap } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { FieldGroup } from '../models';

@Component({
	selector: 'field-group-generator',
	templateUrl: './field-group-generator.component.html',
	styleUrls: ['./field-group-generator.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class FieldGroupGeneratorComponent implements OnInit, OnDestroy {
	@Input() group: FieldGroup;
	@Input() form: UntypedFormGroup;
	errorMessages = {
		required: '',
		minLength: '',
		maxLength: ''
	};

	// get isValid() {
	//   const ctrl = this.form.controls[this.group.name];
	//   if (ctrl) {
	//     return this.group.fields.map(field => ctrl.get(field.name).valid)?.every(val => val === true);
	//   } else {
	//     return true;
	//   }
	//  }
	// get isDirty() {
	//   const ctrl = this.form.controls[this.group.name];
	//   if (ctrl) {
	//     return this.group.fields.map(field => ctrl.get(field.name)?.dirty)?.every(val => val === true);
	//   } else {
	//     return true;
	//   }
	// }
	fieldErrors(field) {
		const ctrl = this.form.controls[this.group.name]?.get(field);
		if (ctrl) {
			return ctrl.errors;
		} else {
			return true;
		}
	}

	//   get showRequiredSign() {
	//     return this.group.fields.map(field => {
	//             return field.validators.map(val => val.type).some(type => type === 'required');
	//         }).includes(true);
	// }
	isHidden$: Observable<boolean>;
	isDisabled$: Observable<boolean>;
	removeCtrlSub: Subscription;
	removeCtrl$;
	ctrlValue;

	constructor() {}

	ngOnInit() {
		// this.group.fields.forEach((field) => {
		//   const validators = field.validators.map(val => this.handleValidator(val));
		//   this.form.controls[this.group.name].get(field.name)?.setValidators(validators);
		// });
		// this.isHidden$ = this.form.valueChanges.pipe(map(val => this.group.hidden || this.groupIsHiddenWhen()));
		// this.isDisabled$ = this.form.valueChanges.pipe(map(val => this.group.disabled || this.groupIsDisabledWhen()));
		// this.removeCtrl$ = this.form.valueChanges.pipe(map(() => this.removeGroupWhen()));
		// this.form.controls[this.field.name].updateValueAndValidity();
	}

	// groupIsHiddenWhen() {
	//   if (!!this.group.hiddenWhen) {
	//     return this.group.hiddenWhen
	//       .map((cond) => {
	//         const fieldControl = this.form.controls[cond.field];
	//         switch (cond.operator) {
	//           case 'is': {
	//             if (cond.value === 'valid') {
	//               return fieldControl.valid ? true : false;
	//             } else if (cond.value === 'invalid') {
	//               return fieldControl.invalid ? true : false;
	//             }
	//             return false;
	//           }
	//           case 'equals': {
	//             return fieldControl.value === cond.value ? true : false;
	//           }
	//           case 'contains': {
	//             return fieldControl.value.includes(cond.value) ? true : false;
	//           }
	//         }
	//       })
	//       .includes(true);
	//   }
	// }

	// groupIsDisabledWhen() {
	//   if (!!this.group.disableWhen) {
	//     return this.group.disableWhen
	//       .map((cond) => {
	//         const fieldControl = this.form.controls[cond.field];
	//         switch (cond.operator) {
	//           case 'is': {
	//             if (cond.value === 'valid') {
	//               return fieldControl.valid ? true : false;
	//             } else if (cond.value === 'invalid') {
	//               return fieldControl.invalid ? true : false;
	//             }
	//             return false;
	//           }
	//           case 'equals': {
	//             return fieldControl.value === cond.value ? true : false;
	//           }
	//           case 'contains': {
	//             return fieldControl.value.includes(cond.value) ? true : false;
	//           }
	//         }
	//       })
	//       .includes(true);
	//   }
	// }

	// removeGroupWhen() {
	//   if (!!this.group.removeControlWhen) {
	//     return this.group.removeControlWhen
	//       .map((cond) => {
	//         const fieldControl = this.form.controls[cond.field];
	//         const ctrl = this.form.controls[this.group.name];
	//         // this.ctrlValue = ctrl.value;
	//         switch (cond.operator) {
	//           case 'is': {
	//             if (cond.value === 'valid') {
	//               if (fieldControl.valid) {
	//                 if (ctrl) {
	//                   this.ctrlValue = ctrl.value;
	//                   this.form.removeControl(this.group.name);
	//                 }
	//                 return true;
	//               } else {
	//                 if (!ctrl) {
	//                   // tslint:disable-next-line: max-line-length
	//                   this.form.addControl(
	//                     this.group.name,
	//                     new FormGroup(this.ctrlValue, this.group.validators.map((val) => this.handleValidator(val))),
	//                   );
	//                   this.form.controls[this.group.name].markAsDirty();
	//                   this.form.updateValueAndValidity();
	//                 }
	//                 return false;
	//               }
	//             } else if (cond.value === 'invalid') {
	//               if (fieldControl.invalid) {
	//                 if (ctrl) {
	//                   this.ctrlValue = ctrl.value;
	//                   this.form.removeControl(this.group.name);
	//                 }
	//                 return true;
	//               } else {
	//                 if (!ctrl) {
	//                   // tslint:disable-next-line: max-line-length
	//                   this.form.addControl(
	//                     this.group.name,
	//                     new FormGroup(this.ctrlValue, this.group.validators.map((val) => this.handleValidator(val))),
	//                   );
	//                   this.form.controls[this.group.name].markAsDirty();
	//                   this.form.updateValueAndValidity();
	//                 }
	//                 return false;
	//               }
	//             }
	//             break;
	//           }
	//           case 'equals': {
	//             if (fieldControl.value === cond.value) {
	//               if (ctrl) {
	//                 this.ctrlValue = ctrl.value;
	//                 this.form.removeControl(this.group.name);
	//               }
	//               return true;
	//             } else {
	//               if (!ctrl) {
	//                 // tslint:disable-next-line: max-line-length
	//                 this.form.addControl(this.group.name, new FormGroup(this.ctrlValue, this.group.validators.map((val) => this.handleValidator(val))));
	//                 this.form.controls[this.group.name].markAsDirty();
	//                 this.form.updateValueAndValidity();
	//               }
	//               return false;
	//             }
	//             break;
	//           }
	//           case 'contains': {
	//             if (fieldControl.value.includes(cond.value)) {
	//               if (ctrl) {
	//                 this.ctrlValue = ctrl.value;
	//                 this.form.removeControl(this.group.name);
	//               }
	//               return true;
	//             } else {
	//               if (!ctrl) {
	//                 // tslint:disable-next-line: max-line-length
	//                 this.form.addControl(
	//                   this.group.name,
	//                   new FormControl(this.ctrlValue, this.group.validators.map((val) => this.handleValidator(val))),
	//                 );
	//                 this.form.controls[this.group.name].markAsDirty();
	//                 this.form.updateValueAndValidity();
	//               }
	//               return false;
	//             }
	//             break;
	//           }
	//         }
	//       })
	//       .includes(true);
	//   }
	// }

	// handleValidator(validator) {
	//   switch (validator.type) {
	//     case 'required': {
	//       this.errorMessages.required = validator.errorMessage;
	//       return Validators.required;
	//     }
	//     case 'minLength': {
	//       this.errorMessages.minLength = validator.errorMessage;
	//       return Validators.minLength(validator.value);
	//     }
	//     case 'maxLength': {
	//       this.errorMessages.maxLength = validator.errorMessage;
	//       return Validators.maxLength(validator.value);
	//     }
	//   }
	// }

	ngOnDestroy() {
		if (this.removeCtrlSub) {
			this.removeCtrlSub.unsubscribe();
		}
	}
}
